import React from "react";
import { Fade } from "@material-ui/core";
import Settings from "components/Settings/Settings";

import "./SettingsScreen.css";

function SettingsScreen() {
  return (
    <Fade in style={{}}>
      <div className="wsh-SettingsScreen">
        <Settings />
      </div>
    </Fade>
  );
}

export default SettingsScreen;
